module.exports = __webpack_public_path__ + "img/Howarth.701375a5.jpg";